// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dd31006766--wrapper--__fx0","icon":"dd31006766--icon--WjFMM","message":"dd31006766--message--lykri"};